import React, {useState, useEffect} from 'react';
import Button from '../Button';
import Image from '../Image';

const AnnualPerformance = () => {
    const hostname = window.location.hostname;
    const [goldButton, setGoldButton] = useState('active')
    const [silverButton, setSilverButton] = useState('non-active')
    const [url, setUrl] = useState('history/gold-price-performance_x.png')

    useEffect(() => {
        if(hostname.includes("silverprice.org")) {
            setGoldButton('non-active')
            setSilverButton('active')
            setUrl('history/silver-price-performance_x.png')
        }
    },[hostname])
    return (
        <div className="annual_performance inner">
        <div className="col-12 col-md-12">
        <ul className="nav text-center" role="tablist">
            <li className={goldButton}>
                <Button varient={goldButton} click={() => {
                    setGoldButton('active')
                    setSilverButton('non-active')
                    setUrl('history/gold-price-performance_x.png')
                    }} value="Gold Price Performance" />
            </li>
            <li className={silverButton}>
                <Button varient={silverButton} click={() => {
                    setGoldButton('non-active')
                    setSilverButton('active')
                    setUrl('history/silver-price-performance_x.png')
                    }} value="Silver Price Performance" />
            </li>
        </ul>
        </div>
        <div className="col-12 col-md-12 tab-content px-0">
            <Image height="740px" chartUrl={url} title={goldButton === 'active' ? "Gold" : "silver"} />
        </div>
        </div>
    )
}

export default AnnualPerformance;
